var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.item.tags),function(tag){return _c('b-badge',{key:'tag_' + _vm.item.id + '_' + tag,attrs:{"variant":"dark"}},[_vm._v(_vm._s(tag))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }